import { get } from "lodash";
import axios from "../utils/axiosConfig";
import { getAllByPlaceholderText } from "@testing-library/react";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};
export const useReportInventoryService = () => {

    const GetReportInveroryService = {
        getReportInventory: () => {
            let url = "/api/reportinventory/getAll";
            return axios.get(`${url}`, { headers });
        },

        getMasterLookupDate: () => {
            let url = "/api/masterLookUpTable/getAll";
            return axios.get(`${url}`, { headers });
        },

        getMasterLookupValuesDate: () => {
            let url = "/api/masterLookUpTable/getLookupValues";
            return axios.get(`${url}`, { headers });
        },

        // saveMctreportinstance: (data: any) => {
        //     let url = "/api/mctreportinstance/create";
        //     return axios.post(`${url}`, data);
        // },

        saveMctreportinstance: async (formData: FormData) => {
            let url = "/api/mctreportinstance/create";
            return axios.post(url, formData, {
                transformRequest: [(data, headers) => {
                    delete headers['Content-Type'];
                    return data;
                }],
            });
        },

        getMctreportinstanceDetailsById: (id: any) => {
            let url = "/api/mctreportinstance/get/" + id;
            return axios.get(`${url}`);
        },

        userLoginService: (data: any) => {
            let url = "/api/user/login";
            return axios.post(`${url}`, data);
        },

        getMcProgramReport: () => {
            let url = "/api/mcprogramreport/getAll";
            return axios.get(`${url}`);
        },

        getCatalogDetailsLIst: (programReportSid: any) => {
            let url = "/api/mcprogramreport/getAllCatalogDetails/" + programReportSid;
            return axios.get(`${url}`);
        },

        getMcUserGroups: () => {
            let url = "/api/userGroup/getAll";
            return axios.get(`${url}`, { headers });
        },

        getMcOrganizationUnits: () => {
            let url = "/api/orgUnits/getAll";
            return axios.get(`${url}`);
        },
        getCheckListItem: (checklistId: any) => {
            let url = "/api/mcprogramreport/getCheckListItemByCheckListId/" + checklistId;
            return axios.get(`${url}`);
        },

        getCheckListItemsByProgramReportSid: (programReportSid: any, checklistTypeLkpcd: any) => {
            let url = "/api/mcprogramreport/getCheckListItemByProgramReportSId/" + programReportSid + "/" + checklistTypeLkpcd;
            return axios.get(`${url}`);
        },

        getCheckListItemByCheckListTypeId: (checklistId: any, checklistTypeLkpcd: any) => {
            let url = "/api/mcprogramreport/getCheckListItemByCheckListTypeId/" + checklistId + "/" + checklistTypeLkpcd;
            return axios.get(`${url}`);
        },


        getProgramReportByProgramReportSid: (programReportSid: any) => {
            let url = "/api/mcprogramreport/getProgramReportByProgramReportSid/" + programReportSid;
            return axios.get(`${url}`);
        },

        getCertificationStatementByDateRange: (startTime: any) => {
            let url = `/api/certification-statement?startTime=${startTime}`;
            return axios.get(`${url}`);
        },

        getReportActivityList: (mctReportInstanceSid: any) => {
            let url = "/api/mctreportactivity/get/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        getAllMcReports: () => {
            let url = "/api/mcreport/getAll";
            return axios.get(`${url}`);
        },

        getAllMcUsers: () => {
            let url = "/api/user/getAll";
            return axios.get(`${url}`);
        },

         getAllUsers: () => {
            let url = "/api/user/getAllUsers";
            return axios.get(`${url}`);
        },

        getUserXUserGroupList: (userSid: any) => {
            let url = "/api/userxusergroup/" + userSid;
            return axios.get(`${url}`);
        },

        getUserXUserGroupListByFilterDate: (userSid: any) => {
            let url = "/api/userxusergroup/" + userSid + "?filterByDate=true";
            return axios.get(`${url}`);
        },

        getRelatedUsers: (userSid: any) => {
            let url = "/api/userxuser/getRelatedUsersWithCombination/" + userSid;
            return axios.get(`${url}`);
        },

        getAllGroupByUserName: (userName: any) => {
            let url = "/api/userxusergroup/getAllGroupByUserSid/" + userName;
            return axios.get(`${url}`);
        },

        getMcUserGroupsByGroupCode: (groupCode: any) => {
            let url = "/api/userxusergroup/getMcUserGroupsByGroupCode/" + groupCode;
            return axios.get(`${url}`);
        },

        getAllMcoAuthDocsFileNames: () => {
            let url = "/api/userxuser/getalldocnames";
            return axios.get(`${url}`);
        },

        getReviewAssignmentList: (userSid: any) => {
            let url = "/api/userReviewAssignment/" + userSid;
            return axios.get(`${url}`);
        },

        getReviewAssignmentListByUnitCode: (orgUnitCode: any) => {
            let url = "/api/userReviewAssignment/unitCode/" + orgUnitCode;
            return axios.get(`${url}`);
        },

        uploadFile: (formData: FormData) => {
            let url = "/api/mcfile/upload";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        mctReportAttachments: (mctReportInstanceSid: any) => {
            let url = "/api/mctReportAttachments/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        getUploadedFilesListBySid: (containerName: any, subContainerName: any) => {
            let url = `/api/mcfile/getall/${containerName}/${subContainerName}`;
            return axios.get(`${url}`);
        },

        deleteUploadedFile: (data: any) => {
            let url = "/api/mcfile/delete";
            return axios.delete(`${url}`, { data });
        },

        updatedUploadedFileStatus: (data: any) => {
            let url = "/api/mctReportAttachments/updateattachmentstatus";
            return axios.post(`${url}`, data);
        },

        uploadFileValidate: (formData: FormData) => {
            let url = "/api/excel/validate";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        saveMcoActions: async (formData: FormData) => {
            let url = "/api/mcoactions/save";
            return axios.post(url, formData, {
                transformRequest: [(data, headers) => {
                    // Remove Content-Type header to let browser set it automatically
                    delete headers['Content-Type'];
                    return data;
                }],
            });
        },

        // saveMcoActions: async (formData: FormData) => {
        //     let url = "/api/mcoactions/save";
        //     return axios.post(url, formData)
        //     //     , {
        //     //     headers: {
        //     //         'Content-Type': 'multipart/form-data'
        //     //     },
        //     // });
        // },

        submitMcoActions: async (formData: FormData) => {
            let url = "/api/mcoactions/submit";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        getLatestActivityByInstanceId: (mctReportInstanceSid: any) => {
            let url = "/api/mctreportactivity/getlastactivity/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        getLAttachmentByActivityId: (mctReportInstanceSid: any) => {
            let url = "/api/mctReportAttachments/get/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        getUploadedFileByAttchanchmentId: (containerName: any, subContainerName: any, attachmentId: any) => {
            let url = `/api/mcfile/getFileByAttachmentId/${containerName}/${subContainerName}/${attachmentId}`;
            return axios.get(`${url}`);
        },

        downloadFileContentAttchanchmentId: (containerName: any, subContainerName: any, attachmentId: any) => {
            let url = `/api/mcfile/downloadFileByAttachmentId/${containerName}/${subContainerName}/${attachmentId}`;
            return axios.get(`${url}`, { responseType: 'blob' });
        },

        downloadTemplateFileByFileName: (containerName: any, fileName: any) => {
            let url = `/api/mcfile/downloadFileByFileName/${containerName}/${fileName}`;
            return axios.get(`${url}`, { responseType: 'blob' });
        },


        deleteActivityAndAttchament: (activityId: any) => {
            let url = "/api/mctreportactivity/deleteactivity/" + activityId;
            return axios.delete(`${url}`);
        },

        updateactivitychecklistattachments: (mctReportActivitySid: any, updatedBy: any, updatedDate: any) => {
            let url = "/api/mctreportactivity/updateactivitychecklistattachments";
            return axios.post(`${url}`, { mctReportActivitySid, updatedBy, updatedDate });
        },

        getReportChecklistByActivityId: (activityId: any) => {
            let url = "/api/mctreportchecklistrspns/getall/" + activityId;
            return axios.get(`${url}`);
        },

        updateActivity: (data: any) => {
            let url = "/api/mctreportactivity/updateactivity";
            return axios.post(`${url}`, data);
        },

        getReportReviewerGroupListByInstanceId: (programReportSid: any, actionLkpcd: any) => {
            let url = "/api/reportReviewerGroup/getAll/" + programReportSid + "/" + actionLkpcd;
            return axios.get(`${url}`);
        },

        getAllReportReviewer: () => {
            let url = "/api/reportReviewerGroup/getAllReportReviewer";
            return axios.get(`${url}`);
        },

        getMCTReportSubActivityByActivityId: (activityId: any) => {
            let url = "/api/mctreportsubactivity/getByActivityId/" + activityId;
            return axios.get(`${url}`);
        },

        getMCTReportSubActivityBySubActivityId: (subActivityId: any) => {
            let url = "/api/mctreportsubactivity/getBySubActivityId/" + subActivityId;
            return axios.get(`${url}`);
        },

        getAttachemntBySubActivityId: (subActivityId: any) => {
            let url = "/api/mctReportAttachments/getAttachmentBySubActivityId/" + subActivityId;
            return axios.get(`${url}`);
        },

        getAllChecklistBySubActivityId: (subActivityId: any) => {
            let url = "/api/mctreportchecklistrspns/getallchecklistsubactivity/" + subActivityId;
            return axios.get(`${url}`);
        },

        getAttachmentByActivityId: (mctReportInstanceSid: any) => {
            let url = "/api/mctReportAttachments/getAttachmentByActivityId/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        saveStateReviewWithoutFile: (data: any) => {
            let url = "/api/stateReviewerActions/saveWithoutFile";
            return axios.post(`${url}`, data);
        },

        submitStateReviewWithoutFile: (data: any) => {
            let url = "/api/stateReviewerActions/submitWithoutFile";
            return axios.post(`${url}`, data);
        },

        saveStateReviewWithFile: (formData: FormData) => {
            let url = "/api/stateReviewerActions/saveWithFile";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        submitStateReviewWithFile: (formData: FormData) => {
            let url = "/api/stateReviewerActions/submitWithFile";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        getAllSubActivitiesByInstanceId: (mctReportInstanceSid: any) => {
            let url = "/api/mctreportsubactivity/getAllSubActivities/" + mctReportInstanceSid;
            return axios.get(`${url}`);
        },

        getAllUserGroupsFromDBByUserGroupId: (usergroupcode: any) => {
            let url = "/api/mcusergroupgroupxpage/" + usergroupcode;
            return axios.get(`${url}`);
        },

        getAllInstaceRecordsForUpload: (planId: any) => {
            let url = "/api/mctreportinstance/getForUpload/" + planId;
            return axios.get(`${url}`);
        },

        saveloadReport: (formData: FormData) => {
            let url = "/api/mctreportinstance/saveuploadreport";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },
        //file upload
        submitUploadReport: (formData: FormData) => {
            let url = "/api/mctreportinstance/submituploadreport";
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        getAllMctfinalmessage: (userId: any) => {
            let url = "/api/mctfinalmessage/getAll/" + userId;
            return axios.get(`${url}`);
        },

        getAllWithUserGroupCode: (data: any) => {
            let url = "/api/mctfinalmessage/getAllWithUserGroupCode";
            return axios.post(`${url}`, data);
        },

        getAllMcAlertsDetails: () => {
            let url = "/api/mcalert/getAll";
            return axios.get(`${url}`);
        },

        getB2cAuthCode: (authCode: any) => {
            let url = "/api/b2c";
            // return axios.get(`${url}`,{ params: { authCode: authCode } });
            return axios.post(`${url}`, {}, {
                headers: {
                    "Authorization-Code": `Bearer ${authCode}`
                }
            });
        },

        checkReviewGroupByUserId: (userSid: any, orgUnitCode: any, planId: any) => {
            let url = `/api/userReviewAssignment/user/${userSid}/unit/${orgUnitCode}/plan/${planId}`;
            return axios.get(`${url}`);
        },

        getAllReportsDashboard: (year: any, quarter: any, month: any) => {
            let url = `/api/reportinventory/dashboard/getAll?year=${year}&quarter=${quarter}&month=${month}`;
            return axios.get(`${url}`);
        },

        getAllReportsScoreDashboard: (year: any, quarter: any, month: any) => {
            let url = `/api/reportinventory/dashboard/report-scores?year=${year}&quarter=${quarter}&month=${month}`;
            return axios.get(`${url}`);
        },

        getActivityCertification: (activitySid: any) => {
            let url = `/api/activity-certification/${activitySid}`;
            return axios.get(`${url}`);
        },

        getAuthorityCount: (userSid: any) => {
            let url = `/api/userxuser/${userSid}/authority-count`;
            return axios.get(`${url}`);
        },

        getUserIpDetails: () => {
            let url = "/api/network-info/ip";
            return axios.get(`${url}`);
        },

        createAuditLog: (data: any) => {
            let url = "/api/mct-audit-log/create";
            return axios.post(`${url}`, data);
        },

        getB2CUserGroupsApi: (data: any) => {
            let url = "/api/getb2cGroups?objectId=" + data;
            return axios.get(`${url}`);
        },

        getOutageBannerApi: () => {
            let url = "/api/banner/current";
            return axios.get(`${url}`);
        },

        updateUserAction: (
            userSid: any,
            action: string,
            userDetails?: any
        ) => {
            const url = `/api/user/action/${userSid}`;
            return axios.put(url, userDetails ?? {}, {
                params: {
                    action
                },
            });
        },

         createUserChangeRequestService: (data: any) => {
            let url = "/api/userchangerequest/create";
            return axios.post(`${url}`, data);
        },

        getUserChangeRequestById: (chngRqstSid: any) => {
            let url = `/api/userchangerequest/get/${chngRqstSid}`;
            return axios.get(`${url}`);
        },

          saveUserChangeRequestService: (chngRqstSid: any, data: any) => {
            let url = `/api/userchangerequest/update/${chngRqstSid}`;
            return axios.post(`${url}`, data);
        },

         submitUserChangeRequestService: (chngRqstSid: any, data: any) => {
            let url = `/api/userchangerequest/submit/${chngRqstSid}`;
            return axios.post(`${url}`, data);
        },

         getMcPlans: () => {
            let url = "/api/mcplan/getAll";
            return axios.get(`${url}`);
        },

        getAllMcUserDetailsByMcoStaffCtgry: (orgUnitCd: any, mcoStaffCtgry:any, userSid: any) => {
            let url = `/api/user/getAllMcUserDetailsByMcoStaffCtgry/${orgUnitCd}/${mcoStaffCtgry}/${userSid}`;
            return axios.get(`${url}`);
        },

         uploadMcoAuthorityFile: (file: FormData) => {
            let url = "/api/userchangerequest/uploadMcoAuthorityFile";
            return axios.post(url, file, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        getUserChangeRequestByEmailAndOrgUnit: (data: any) => {
            let url = `/api/userchangerequest/get/chngReqStatus`;
            return axios.post(`${url}`, data);
        },

         getAllDomainsByOrgCode: (orgCode: any) => {
            let url = `/api/mcOrgDomain/getAll/${orgCode}`;
            return axios.get(`${url}`);
        },
    }

    return GetReportInveroryService;

}